export const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&#^()\-+{}:<>])[A-Za-z\d@$!%*?&#^()\-+{}:<>]{8,}$/;
